import type { FaireProductEntity } from "../../entity_types/product";

export const p_b9tjh6cxhb: FaireProductEntity = {
  token: "p_b9tjh6cxhb",
  type: "product",
  name: "Nature Slut Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/5ceb6bfe203d36946f7aa63a4356d45fa6f28320b61a8412b1ed0851c76cfcaf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/08c8879c2c4d130e91acd038fb850bf5fad6bd4a14edd01f147259bfd5f4fc02.jpeg",
    "https://cdn.faire.com/fastly/67b797e728daeee8457f5c1ce63e5c15516bd90f79e069313e88ee229100e497.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/e9a1becfae7f1c9b75ea6821f203841694c39815cff03a783983fbfa31c83868.jpeg",
    "https://cdn.faire.com/fastly/1c1465367633a2143d5dd9b6dfa12aa31767f52e2ad0a7bbcb0d99f0073d3a5e.jpeg"
  ],
  priceDollars: 6.75,
  description: "Does nature turn you on? If long hard hikes, big trees, wet creeks, and a fresh breeze all over your face make you happy... you're probably a nature slut, and you definitely need these socks.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:11.888Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
